var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* eslint-disable @typescript-eslint/no-floating-promises */
import { Box, Button, Flex, Image, Spinner, Text, Toast } from 'pcln-design-system';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { submitChatMessages } from './submitChatMessages';
import { ScrollIntoView } from './ScrollIntoView';
import { History, SuccessOutline } from 'pcln-icons';
import { DialogLoading } from './DialogLoading';
import { ChatbotDataContext } from './context/ChatbotDataContext';
import { useDialogStylesContext } from './hooks/useDialogStylesContext';
import analytics from './analytics/analytics';
import TryAgain from './components/TryAgain';
import pennyBroadcast, { BroadcastType, usePennySubscriber } from './utils/pennyBroadcast';
// import DebugComponent from './DebugComponent'
import { LoadMorePrompts, LoadMorePromptsWrapper, ToastWrapper } from './ChatContent.styles';
import fetchWithTimeout from './utils/fetchWithTimeout';
import { ChatMessagesList } from './ChatMessagesCollections';
import Loading from './components/Loading';
import { useStandaloneStyles } from './context/StandaloneStyleContext';
import { ChatInput } from './components/ChatInput/ChatInput';
import ClearHistory from './svgs/ClearHistory';
import { browserStorage } from './utils/browserStorage';
import { useChatMessagesContext } from './hooks/useChatMessagesContext';
import { useLoadingStateContext } from './hooks/useLoadingStateContext';
import { useChatUIContext } from './hooks/useChatUIContext';
import { useMarkerComponentMemo } from './hooks/useMarkerComponentMemo';
import { removePennyInitialMessageKeys } from './utils/removePennyInitialMessageKeys';
const MIC_SENSITIVITY = 1;
const MIC_TIMEOUT = 2000;
const GREETING_MESSAGE = "Hi, I'm Penny, your virtual travel assistant! How can I help you today?";
const TRAVEL_BOT_LOGO = 'https://s1.pclncdn.com/design-assets/pcln-bot/logos/pcln_bot_opener_logo_no_border_v1.1.svg';
/**
 * ChatMainContentSection
 * Main chat content
 * @public
 */
const ChatMainContentSection = ({
  retrievalLoading = false,
  visibilityChannel
}) => {
  var _a, _b, _c;
  const {
    setLoadMoreMessages,
    submitChatMessagesPayload,
    handleMarkerResponse,
    fetchRequestOptions,
    markerComponents,
    errorMessage,
    setErrorMessage,
    setIsDisablingInputValue,
    fullStreamingTexts,
    setStreamingText,
    debugMode,
    enableVoice,
    discoveryCitySelected,
    pushPrompt,
    audioPlayerRef,
    transcriptionFetchRequestOptions,
    loadMoreMessages,
    isDisablingInput,
    accountLessAccessToken,
    accountLessTripsAccessPayload,
    setHotelPinOnMap
  } = useContext(ChatbotDataContext);
  if (accountLessTripsAccessPayload) {
    submitChatMessagesPayload.accountLessTripsAccessPayload = accountLessTripsAccessPayload;
  }
  const memoMarkerComponents = useMarkerComponentMemo(markerComponents);
  const {
    chatMessages,
    setChatMessages
  } = useChatMessagesContext();
  const {
    openErrorComponent,
    setOpenErrorComponent
  } = useChatUIContext();
  const {
    isLoading,
    setLoadingStatus,
    loadingStatusMessages,
    setLoadingStatusMessage
  } = useLoadingStateContext();
  const contentRef = useRef(null);
  const [isRecordingError, setIsRecordingError] = useState(false);
  const isVoiceEnabled = enableVoice && !isRecordingError;
  const [mediaRecorder, setMediaRecorder] = useState();
  const [isRetrievingAudio, setIsRetrievingAudio] = useState(false);
  const [isPlayingAudio, setIsPlayingAudio] = useState(false);
  const [hasUserGrantedMicAccess, setHasUserGrantedMicAccess] = useState(false);
  const messagesEndRef = useRef(null);
  const loadRef = useRef(null);
  const [lastMessage, setLastmessage] = useState('');
  const [showClearedHistory, setShowClearedHistory] = useState(false);
  const [isClearedHistoryActive, setIsClearedHistoryActive] = useState(false);
  const [currScrollHeight, setCurrentScrollHeight] = useState(0);
  const {
    isSessionActive,
    hotelPayload
  } = submitChatMessagesPayload;
  const isAudioPlaybackEnabledRef = useRef(false);
  const {
    isShowMoreListingCards = false
  } = hotelPayload !== null && hotelPayload !== void 0 ? hotelPayload : {};
  useEffect(() => {
    var _a;
    if (chatMessages) {
      // Find the last user message
      const lastContent = (_a = chatMessages.find(message => message.role === 'user')) === null || _a === void 0 ? void 0 : _a.content;
      if (lastContent) {
        setLastmessage(lastContent);
      }
    }
  }, [chatMessages.length]);
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest'
      });
    }
  }, []);
  // Ref necessary to hold current value of the state for use in useCallback. Otherwise we'd only use
  // the value of the state at initialization.
  const streamingAssistantMessageVoiceRef = useRef([]);
  const [streamingAssistantMessageVoice, setStreamingAssistantMessageVoice] = useState([]);
  const pennyBroadcastListener = useCallback(event => {
    if (event.data.type === BroadcastType.AUDIO_QUEUE_DRAINED) {
      setIsRetrievingAudio(false);
      setStreamingAssistantMessageVoice([]);
    } else if (event.data.type === BroadcastType.AUDIO_RETRIEVAL_INITIATED) {
      setIsRetrievingAudio(true);
    } else if (event.data.type === BroadcastType.AUDIO_PLAYBACK_STARTED) {
      setIsPlayingAudio(true);
      setStreamingAssistantMessageVoice([...streamingAssistantMessageVoiceRef.current, event.data.data]);
    } else if (event.data.type === BroadcastType.AUDIO_PLAYBACK_STOPPED) {
      setIsPlayingAudio(!!event.data.hasMoreMessages);
    } else if (event.data.type === BroadcastType.ENABLE_AUDIO_PLAYBACK) {
      isAudioPlaybackEnabledRef.current = true;
    } else if (event.data.type === BroadcastType.DISABLE_AUDIO_PLAYBACK) {
      isAudioPlaybackEnabledRef.current = false;
    }
  }, [setIsRetrievingAudio]);
  // This just ensures that the value in the ref is always the same as the state
  useEffect(() => {
    streamingAssistantMessageVoiceRef.current = [...streamingAssistantMessageVoice];
  }, [streamingAssistantMessageVoice]);
  /**
   * Checks to see if the user has previously granted access to their microphone.
   */
  useEffect(() => {
    const checkMicAccess = () => __awaiter(void 0, void 0, void 0, function* () {
      var _a;
      if (isVoiceEnabled) {
        if ((_a = navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.enumerateDevices) {
          try {
            const devices = yield navigator.mediaDevices.enumerateDevices();
            const hasUserPreviouslyGrantedMicAccess = devices.some(device => {
              return device.kind === 'audioinput' && !!device.label;
            });
            setHasUserGrantedMicAccess(hasUserPreviouslyGrantedMicAccess);
          } catch (err) {
            analytics.logError({
              message: 'Unable to detect microphone access',
              error: JSON.stringify(err)
            });
          }
        }
      }
    });
    checkMicAccess();
  }, [enableVoice]);
  usePennySubscriber(pennyBroadcastListener);
  const submitChatMessagesOptions = {
    setChatMessages,
    setStreamingText,
    setLoadingStatus,
    setErrorMessage,
    setIsDisablingInputValue,
    requestOptions: Object.assign(Object.assign({}, fetchRequestOptions), {
      headers: Object.assign(Object.assign({}, fetchRequestOptions === null || fetchRequestOptions === void 0 ? void 0 : fetchRequestOptions.headers), accountLessAccessToken ? {
        'account-less-access-token': accountLessAccessToken
      } : {})
    }),
    markerComponents,
    handleMarkerResponse,
    setLoadingStatusMessage
  };
  const sendUserMessage = text => __awaiter(void 0, void 0, void 0, function* () {
    const chatMessage = {
      role: 'user',
      content: text,
      timestamp: new Date()
    };
    const promptMessage = {
      role: 'user',
      content: text
    };
    setChatMessages([...chatMessages, chatMessage]);
    yield submitChatMessages(Object.assign(Object.assign({
      submitChatMessagesPayload: Object.assign(Object.assign({}, submitChatMessagesPayload), {
        prompts: [promptMessage],
        includeSpeech: !!isVoiceEnabled && isAudioPlaybackEnabledRef.current
      }),
      // Local state control
      chatMessages: [...chatMessages, chatMessage]
    }, submitChatMessagesOptions), {
      requestOptions: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions), {
        headers: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions.headers), accountLessAccessToken ? {
          'account-less-access-token': accountLessAccessToken
        } : {})
      })
    }));
  });
  useEffect(() => {
    if (discoveryCitySelected || pushPrompt && !retrievalLoading) {
      const chatContent = discoveryCitySelected ? `Looking for hotels in ${discoveryCitySelected}` : pushPrompt;
      const chatMessage = {
        content: chatContent,
        date: new Date(),
        role: 'user'
      };
      const promptMessage = {
        content: chatContent,
        role: 'user'
      };
      const updatedChatMessages = [...chatMessages, chatMessage];
      //  set user's message
      setChatMessages(updatedChatMessages);
      // submit user's message to get response
      submitChatMessages(Object.assign(Object.assign({
        submitChatMessagesPayload: Object.assign(Object.assign({}, submitChatMessagesPayload), {
          includeSpeech: !!isVoiceEnabled && isAudioPlaybackEnabledRef.current,
          prompts: [promptMessage]
        }),
        setOpenErrorComponent,
        chatMessages: updatedChatMessages
      }, submitChatMessagesOptions), {
        requestOptions: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions), {
          headers: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions.headers), accountLessAccessToken ? {
            'account-less-access-token': accountLessAccessToken
          } : {})
        })
      }));
    }
  }, [discoveryCitySelected, pushPrompt]);
  const sendAudioToTranscriptionService = file => __awaiter(void 0, void 0, void 0, function* () {
    const formData = new FormData();
    formData.append('file', file);
    try {
      const response = yield fetchWithTimeout((transcriptionFetchRequestOptions === null || transcriptionFetchRequestOptions === void 0 ? void 0 : transcriptionFetchRequestOptions.url) || '/genai-svc/genai/transcriptions', {
        method: 'POST',
        body: formData,
        headers: {
          accept: 'application/json'
        }
      }, (transcriptionFetchRequestOptions === null || transcriptionFetchRequestOptions === void 0 ? void 0 : transcriptionFetchRequestOptions.timeout) || 10000);
      const data = yield response.json();
      return data.text;
    } catch (e) {
      analytics.logError({
        message: 'Error submitting audio to transcription service',
        error: JSON.stringify(e)
      });
    }
  });
  const startRecording = function () {
    return __awaiter(this, void 0, void 0, function* () {
      const audioPlayer = audioPlayerRef.current;
      audioPlayer.autoplay = true;
      // This is some dummy inperceptible audio content that can be played when teh user clicks the start recording
      // button so that the audio element has access to play audio in the future.
      audioPlayer.src = 'data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV';
      // Check if the user has granted mic access. If they haven't, request it.
      if (!hasUserGrantedMicAccess) {
        yield navigator.mediaDevices.getUserMedia({
          audio: true
        });
        setHasUserGrantedMicAccess(true);
        return;
      }
      // Send message to stop playback
      pennyBroadcast({
        type: BroadcastType.INTERRUPT_AUDIO_PLAYBACK,
        sender: 'ChatContent.startRecording()'
      });
      try {
        const stream = yield navigator.mediaDevices.getUserMedia({
          audio: true
        });
        const audioContext = new AudioContext();
        const analyser = audioContext.createAnalyser();
        const source = audioContext.createMediaStreamSource(stream);
        source.connect(analyser);
        analyser.fftSize = 2048;
        const recorder = new MediaRecorder(stream);
        setMediaRecorder(recorder);
        const chunks = [];
        recorder.ondataavailable = event => {
          chunks.push(event.data);
        };
        let silenceStart = performance.now();
        let isRecording = true;
        let userSpoken = false;
        const checkForAudioInput = () => {
          if (!isRecording) {
            return;
          }
          const dataArray = new Uint8Array(analyser.fftSize);
          analyser.getByteTimeDomainData(dataArray);
          // Line representation of audio
          // Commenting this out because I think John U will want to run a test with it in the near future.
          // There are additional commented out lines of code in RecordingIndicator.tsx that are related to this.
          // const canvas = document.getElementById('audio-visualization-canvas') as HTMLCanvasElement
          // const canvasCtx = canvas.getContext('2d')
          // canvasCtx.clearRect(0, 0, canvas.width, canvas.height)
          // const bufferLength = analyser.frequencyBinCount
          // canvasCtx.fillStyle = 'rgba(200, 200, 200, 0)'
          // canvasCtx.fillRect(0, 0, canvas.width, canvas.height)
          // canvasCtx.lineWidth = 4
          // canvasCtx.lineJoin = 'round'
          // canvasCtx.lineCap = 'round'
          // const lineGradient = canvasCtx.createLinearGradient(0, 0, canvas.width, 0)
          // lineGradient.addColorStop(0, 'rgba(255, 255, 255, 0)')
          // lineGradient.addColorStop(.1, 'rgba(255, 255, 255, .3)')
          // lineGradient.addColorStop(.15, 'rgba(255, 255, 255, .3)')
          // lineGradient.addColorStop(.5, 'rgba(255, 255, 255, .0)')
          // lineGradient.addColorStop(.85, 'rgba(255, 255, 255, .3)')
          // lineGradient.addColorStop(.9, 'rgba(255, 255, 255, .3)')
          // lineGradient.addColorStop(1, 'rgba(255, 255, 255, 0)')
          // canvasCtx.strokeStyle = lineGradient
          // canvasCtx.shadowColor = 'rgba(150, 84, 205, 0.5)'
          // canvasCtx.shadowBlur = 20 // Increase this value for more blur
          // canvasCtx.beginPath()
          // const sliceWidth = canvas.width / bufferLength
          // let x = 0
          // for (let i = 0; i < bufferLength; i++) {
          //   const v = dataArray[i] / 128.0;
          //   const y = v * (canvas.height / 2);
          //   if (i === 0) {
          //     canvasCtx.moveTo(x, y);
          //   } else {
          //     canvasCtx.lineTo(x, y);
          //   }
          //   x += sliceWidth;
          // }
          // canvasCtx.lineTo(canvas.width, canvas.height / 2);
          // canvasCtx.stroke();
          // End of line representation
          const currTime = performance.now();
          if (dataArray.some(value => value - 128 > MIC_SENSITIVITY || value - 128 < -MIC_SENSITIVITY)) {
            if (!userSpoken) {
              pennyBroadcast({
                type: BroadcastType.USER_IS_TALKING,
                sender: 'ChatContent.checkSilence()'
              });
              userSpoken = true;
            }
            silenceStart = currTime; // Reset the silence start time
          } else if (userSpoken && currTime - silenceStart > MIC_TIMEOUT) {
            pennyBroadcast({
              type: BroadcastType.USER_IS_SILENT,
              sender: 'ChatContent.checkSilence()'
            });
            recorder.stop();
            isRecording = false;
          }
          if (isRecording) {
            requestAnimationFrame(checkForAudioInput);
          }
        };
        checkForAudioInput();
        recorder.onstop = () => __awaiter(this, void 0, void 0, function* () {
          pennyBroadcast({
            type: BroadcastType.VOICE_RECORDING_STOPPED,
            sender: 'ChatContent.onstop()'
          });
          // Combine the chunks into a single audio Blob
          const audioBlob = new Blob(chunks, {
            type: 'audio/mp3'
          });
          const audioFile = new File([audioBlob], 'audio_rec.mp3', {
            type: 'audio/mp3'
          });
          // Check for valid audio. Safari seems to have an issue in recording sometimes and when it does the total blob size is very small
          // This means we have an entry point for manually detecting when the recording fails
          if (audioBlob.size < 10000) {
            analytics.logError({
              message: "Could not transcribe audio because there wasn't enough audio in the recording. Possibly iOS Safari issue. Size of the audio blob is " + audioBlob.size + ' but anything less than 10000 is ignored. The user agent of the device where the error occurred was ' + (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent)
            });
            pennyBroadcast({
              type: BroadcastType.INTERRUPT_AUDIO_PLAYBACK,
              sender: 'ChatContent.recorder.onstop()'
            });
            setIsRecordingError(true);
            return;
          }
          // take the audio blob and send it to the server
          try {
            const text = yield sendAudioToTranscriptionService(audioFile);
            yield sendUserMessage(text);
          } catch (e) {
            analytics.logError({
              message: 'Could not transcribe audio',
              error: JSON.stringify(e)
            });
          }
        });
        const isSafari = navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') === -1;
        const timeSlice = isSafari ? 1000 : null;
        recorder.start(timeSlice);
        pennyBroadcast({
          type: BroadcastType.VOICE_RECORDING_STARTED,
          sender: 'ChatContent'
        });
        pennyBroadcast({
          type: BroadcastType.ENABLE_AUDIO_PLAYBACK,
          sender: 'ChatContent'
        });
      } catch (error) {
        analytics.logError({
          message: 'Could not start recording',
          error: JSON.stringify(error)
        });
      }
    });
  };
  const stopRecording = function () {
    if (mediaRecorder && mediaRecorder.state === 'recording') {
      mediaRecorder.stop();
    }
  };
  useEffect(() => {
    const onScroll = () => {
      const scrollableDiv = contentRef.current;
      if (!scrollableDiv) {
        return;
      }
    };
    // eslint-disable-next-line no-unused-expressions
    contentRef.current && contentRef.current.addEventListener('scroll', onScroll);
    return () => contentRef.current && contentRef.current.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    var _a;
    const curHeight = (_a = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight;
    if (contentRef.current) {
      contentRef.current.scrollTop = curHeight - currScrollHeight;
    }
  }, [loadMoreMessages]);
  /**
   * Handles initial chat message submission based on session state and separator conditions.
   * Submits a separator message when a separator component or session initialization is present.
   * Submits initial prompts for new messages based on session state and retrieval loading status.
   * Includes speech functionality when voice is enabled and audio playback is allowed.
   */
  useEffect(() => {
    var _a;
    const submitChatMessagePayloadObj = Object.assign(Object.assign({
      setOpenErrorComponent,
      chatMessages
    }, submitChatMessagesOptions), {
      requestOptions: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions), {
        headers: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions.headers), accountLessAccessToken ? {
          'account-less-access-token': accountLessAccessToken
        } : {})
      })
    });
    const isNewMessageWithSession = !browserStorage.isInitialMessageSubmitted() && !retrievalLoading || (chatMessages === null || chatMessages === void 0 ? void 0 : chatMessages.length) === 1 && ((_a = chatMessages === null || chatMessages === void 0 ? void 0 : chatMessages[0]) === null || _a === void 0 ? void 0 : _a.displayComponentName) === 'SESSION_INITIALIZED';
    /**
     * In penny-portal, we are submitting the initial message from the landing page.
     * Therefore, we don't want to submit a second time. This can be prevented by checking
     * if the productId is not -1.
     */
    if (isNewMessageWithSession && !pushPrompt && submitChatMessagesPayload.productId !== -1) {
      browserStorage.setInitialMessageSubmitted();
      submitChatMessages(Object.assign({
        submitChatMessagesPayload: Object.assign(Object.assign({}, submitChatMessagesPayload), {
          // Hard code the initail
          prompts: [{
            role: 'user',
            content: 'Hello!!!'
          }],
          includeSpeech: !!isVoiceEnabled && isAudioPlaybackEnabledRef.current
        })
      }, submitChatMessagePayloadObj));
    }
  }, [retrievalLoading]);
  /**
   * When openErrorComponent fires (excepting initial load),
   * check to see if we can resubmit the last user msg.
   */
  const previousErrorState = useRef(openErrorComponent);
  useEffect(() => {
    var _a, _b;
    if (previousErrorState.current === openErrorComponent) {
      return;
    }
    previousErrorState.current = openErrorComponent;
    const curHeight = (_a = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight;
    setIsDisablingInputValue(openErrorComponent && !isDisablingInput);
    if ((chatMessages === null || chatMessages === void 0 ? void 0 : chatMessages.length) > 0 && ((_b = chatMessages[chatMessages.length - 1]) === null || _b === void 0 ? void 0 : _b.role) === 'user') {
      submitChatMessages(Object.assign(Object.assign({
        submitChatMessagesPayload: Object.assign(Object.assign({}, submitChatMessagesPayload), {
          prompts: [{
            role: 'user',
            content: 'Looks like something went wrong.'
          }],
          includeSpeech: false
        }),
        setOpenErrorComponent,
        chatMessages
      }, submitChatMessagesOptions), {
        requestOptions: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions), {
          headers: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions.headers), accountLessAccessToken ? {
            'account-less-access-token': accountLessAccessToken
          } : {})
        })
      }));
      if (contentRef.current) {
        contentRef.current.scrollTop = curHeight - currScrollHeight;
      }
    }
  }, [openErrorComponent]);
  useEffect(() => {
    if (!isLoading && isClearedHistoryActive && !showClearedHistory) {
      setShowClearedHistory(true);
      setTimeout(() => {
        setIsClearedHistoryActive(false);
        setShowClearedHistory(false);
      }, 1000);
    }
  }, [isClearedHistoryActive]);
  function submitChatMessageInMarkerComponent(msg, updatedChatMessage, headers) {
    // Based on quick actions, display marker component directly
    if (!msg.content && msg.displayComponentName) {
      setChatMessages([...chatMessages, msg]);
    } else {
      submitChatMessages(Object.assign(Object.assign({
        submitChatMessagesPayload: Object.assign(Object.assign({}, submitChatMessagesPayload), {
          includeSpeech: !!isVoiceEnabled && isAudioPlaybackEnabledRef.current,
          prompts: [msg]
        }),
        setOpenErrorComponent,
        // Local state control
        chatMessages: !Array.isArray(updatedChatMessage) || updatedChatMessage.length === 0 ? chatMessages : updatedChatMessage
      }, submitChatMessagesOptions), {
        requestOptions: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions), {
          headers: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions.headers), headers || {})
        })
      }));
    }
  }
  function handleClearHistory() {
    const submitChatMessagePayloadObj = Object.assign(Object.assign({
      setOpenErrorComponent,
      chatMessages: []
    }, submitChatMessagesOptions), {
      requestOptions: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions), {
        headers: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions.headers), accountLessAccessToken ? {
          'account-less-access-token': accountLessAccessToken
        } : {})
      })
    });
    browserStorage.removeItem('pennysid');
    removePennyInitialMessageKeys();
    setChatMessages([]);
    setIsClearedHistoryActive(true);
    setHotelPinOnMap([]);
    submitChatMessages(Object.assign({
      submitChatMessagesPayload: Object.assign(Object.assign({}, submitChatMessagesPayload), {
        prompts: [{
          role: 'user',
          content: 'Hello!!!'
        }],
        includeSpeech: !!isVoiceEnabled && isAudioPlaybackEnabledRef.current
      })
    }, submitChatMessagePayloadObj));
  }
  const dialogStyles = useDialogStylesContext();
  const standaloneStyles = useStandaloneStyles();
  let styles;
  const isDialogStylesEmpty = !(dialogStyles === null || dialogStyles === void 0 ? void 0 : dialogStyles.topLevelBoxStyle) || Object.keys(dialogStyles.topLevelBoxStyle).length === 0;
  if (!isDialogStylesEmpty) {
    styles = dialogStyles;
  } else {
    styles = standaloneStyles;
  }
  return React.createElement(React.Fragment, null, retrievalLoading && isSessionActive ? React.createElement(Loading, null) : React.createElement(Box, Object.assign({}, Object.assign(Object.assign({}, styles.topLevelBoxStyle), {
    height: isVoiceEnabled && !isDialogStylesEmpty ? 'calc(100% - 133px)' : 'calc(100% - 120px)'
  }), {
    key: 'chat-dialog-transcript-container',
    ref: contentRef
  }), showClearedHistory ? React.createElement(ToastWrapper, {
    width: '300px'
  }, React.createElement(Toast, {
    color: 'success',
    colorScheme: 'successLight',
    icon: React.createElement(SuccessOutline, null),
    hideClose: true
  }, "Chat History Cleared")) : null, React.createElement(Flex, Object.assign({}, styles.contentFlexStyle), ((_a = chatMessages === null || chatMessages === void 0 ? void 0 : chatMessages[0]) === null || _a === void 0 ? void 0 : _a.content) !== GREETING_MESSAGE && ((_b = chatMessages === null || chatMessages === void 0 ? void 0 : chatMessages[0]) === null || _b === void 0 ? void 0 : _b.displayComponentName) !== 'SESSION_INITIALIZED' && ((_c = chatMessages === null || chatMessages === void 0 ? void 0 : chatMessages[0]) === null || _c === void 0 ? void 0 : _c.content) !== '<SEPARATOR>' && !loadMoreMessages && isSessionActive ? React.createElement(LoadMorePromptsWrapper, {
    ref: loadRef
  }, React.createElement(LoadMorePrompts, {
    onClick: function () {
      var _a;
      setLoadMoreMessages(true);
      setCurrentScrollHeight((_a = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight);
    }
  }, React.createElement(Button, {
    variation: 'link'
  }, ' ', React.createElement(History, {
    size: 20,
    mr: 2
  }), " View History")), React.createElement(LoadMorePrompts, {
    onClick: function () {
      handleClearHistory();
      setLoadMoreMessages(true);
    }
  }, React.createElement(Button, {
    variation: 'link',
    ml: 4
  }, ' ', React.createElement(ClearHistory, {
    size: 15
  }), " ", React.createElement(Text, {
    ml: 2
  }, " Clear History ")))) : null, React.createElement(Flex, {
    justifyContent: 'center'
  }, loadMoreMessages ? React.createElement(Box, {
    mb: 4
  }, React.createElement(Spinner, {
    size: 40,
    color: 'purple'
  }, React.createElement(Image, {
    src: TRAVEL_BOT_LOGO,
    width: 28,
    alt: 'Penny chat avatar'
  }))) : null), React.createElement(ChatMessagesList, {
    messagesEndRef: messagesEndRef,
    isStandalone: isDialogStylesEmpty,
    chatMessages: chatMessages,
    isRetrievingAudio: isRetrievingAudio,
    markerComponents: memoMarkerComponents,
    isLoading: isLoading,
    debugMode: debugMode,
    setIsDisablingInputValue: setIsDisablingInputValue,
    setChatMessages: setChatMessages,
    submitMessages: submitChatMessageInMarkerComponent,
    submitChatMessageInMarkerComponent: submitChatMessageInMarkerComponent,
    isShowMoreListingCards: isShowMoreListingCards,
    submitQuickActionMessage: function (action) {
      const {
        chatContent,
        promptContent
      } = action;
      const promptMessage = {
        content: promptContent || chatContent,
        role: 'user'
      };
      const chatMessage = {
        content: chatContent,
        role: 'user'
      };
      const updatedChatMessages = [...chatMessages, chatMessage];
      // set user's message
      setChatMessages(updatedChatMessages);
      // submit user's message to get response
      submitChatMessages(Object.assign(Object.assign({
        submitChatMessagesPayload: Object.assign(Object.assign({}, submitChatMessagesPayload), {
          prompts: [promptMessage],
          includeSpeech: !!isVoiceEnabled && isAudioPlaybackEnabledRef.current
        }),
        setOpenErrorComponent,
        // Local state control
        chatMessages: updatedChatMessages
      }, submitChatMessagesOptions), {
        requestOptions: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions), {
          headers: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions.headers), accountLessAccessToken ? {
            'account-less-access-token': accountLessAccessToken
          } : {})
        })
      }));
    }
  }), errorMessage && openErrorComponent && React.createElement(ScrollIntoView, null, React.createElement(TryAgain, {
    lastMessage: lastMessage
  })), !isAudioPlaybackEnabledRef.current && isLoading &&
  // loading status for the bot only
  React.createElement(ScrollIntoView, null, React.createElement(DialogLoading, {
    streamingText: fullStreamingTexts,
    lastMessage: lastMessage,
    loadingStatusMessages: loadingStatusMessages
  })), isAudioPlaybackEnabledRef.current && (isRetrievingAudio || isLoading) && React.createElement(ScrollIntoView, null, React.createElement(DialogLoading, {
    enableVoice: isVoiceEnabled,
    playingAudio: isPlayingAudio,
    streamingText: streamingAssistantMessageVoice.join(' '),
    lastMessage: lastMessage
  }))), isDialogStylesEmpty ? React.createElement("div", {
    ref: messagesEndRef,
    style: {
      height: 0
    }
  }) : React.createElement(React.Fragment, null)), React.createElement(ChatInput, {
    showToolTip: isDialogStylesEmpty,
    styles: styles,
    isVoiceEnabled: isVoiceEnabled,
    startRecording: startRecording,
    stopRecording: stopRecording,
    isAudioPlaybackEnabledRef: isAudioPlaybackEnabledRef,
    submitChatMessagesOptions: submitChatMessagesOptions,
    visibilityChannel: visibilityChannel
  }));
};
export default React.memo(ChatMainContentSection);